import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class DashboardService {

    getEventRoute = '/api/newevents/';

    constructor(private dataService: DataService) {
    };

    save(data: any) {
        return this.dataService.post('/api/newevents', data).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    saveNew(data: any) {
        return this.dataService.post('/api/schedule', data).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getActualTarget(data: any, refresh: boolean) {
        // tslint:disable-next-line: max-line-length
        return this.dataService.getData('/api/tripentry/targetactual/' + data.region + '/' + data.division + '/' + data.subdivision + '/' + data.uomtype, refresh);
    }

    getOnDuty(data: any, refresh: boolean) {
        // tslint:disable-next-line: max-line-length
        return this.dataService.getData('/api/vehiclestatus/ondutystatus/' + data.region + '/' + data.division + '/' + data.subdivision, refresh);
    }

    revenueData(data: any, refresh: boolean) {
        // tslint:disable-next-line: max-line-length
        return this.dataService.getData('/api/tripentry/revenue/' + data.region + '/' + data.division + '/' + data.subdivision + '/' + data.revenueFilterType, refresh);
    }

    chartData(data: any, refresh: boolean) {
        // tslint:disable-next-line: max-line-length
        return this.dataService.getData('/api/vehiclestatus/dailystatus/' + data.vehicleId + '/' + data.startts, refresh);
    }

    getNotification(refresh: boolean) {
        return this.dataService.getData('/api/eventnotification/allevents', refresh);
    }

    getNotificationBlink(refresh: boolean) {
        return this.dataService.getData('/api/eventnotification/todayevents', refresh);
    }

    // getmhireDashboard(regId,divisionId,subdivisionId,refresh: boolean) {
    //     return this.dataService.getData('/api/mhirebooking/dashboard/'
    //     + regId + '/' + divisionId + '/' + subdivisionId
    //     , refresh);
    // }

    // gethireChartDashboard(regId,divisionId,subdivisionId,refresh: boolean) {
    //     return this.dataService.getData('/api/mhirebooking/dashboardchart/'
    //     + regId + '/' + divisionId + '/' + subdivisionId
    //     , refresh);
    // }

    getmhireDashboard(regId, divisionId, subdivisionId, blockId, vehicleCategoryId, month, year, refresh: boolean) {
        return this.dataService.getData('/api/mhirebooking/dashboard/'
            + regId + '/' + divisionId + '/' + subdivisionId + '/' + blockId
            + '/' + vehicleCategoryId + '/' + month + '/' + year, refresh);
    }

    gethireChartDashboard(regId, divisionId, subdivisionId, blockId, vehicleCategoryId,financialYearId, refresh: boolean) {
        return this.dataService.getData('/api/mhirebooking/dashboardchart/'
            + regId + '/' + divisionId + '/' + subdivisionId + '/' + blockId
            + '/' + vehicleCategoryId +'/'+ financialYearId,refresh);
    }

    getMonthlyUtilizationData(regId, divisionId, subdivisionId, blockId, vehicleCategoryId, month, year, refresh: boolean) {
        return this.dataService.getData('/api/mhirebooking/monthlyutilization/' + regId + '/' + divisionId + '/' + subdivisionId + '/' + blockId
            + '/' + vehicleCategoryId + '/' + month + '/' + year, refresh)
    }

    getWeeklyUtilizationData(regId, divisionId, subdivisionId, blockId, vehicleCategoryId, date, refresh: boolean) {
        return this.dataService.getData('/api/mhirebooking/dailystatus/' + regId + '/' + divisionId + '/' + subdivisionId + '/' + blockId
            + '/' + vehicleCategoryId + '/' + date, refresh)
    }

    getDashboardDrillData(data, refresh: boolean) {
        return this.dataService.getData('/api/dbtstatetarget/dbtstatetargetlist/' + data.financialYearId + '/' + data.departmentId +  '/' + data.dbtGoId + '/' + data.dbtSchemeId + '/' + data.dbtComponentId + '/' + data.dbtProductId + '/' + data.divisionId + '/' + data.subDivisionId, refresh)
    }

   
    getSmamDashboard(regionId,divisionId,subDivisionId,districtId,bolckId,villageId,financialYearId,departmentId,goId,SchemeId,ComponentId,MachineryId,refresh){
        return this.dataService.getData('/api/SMAMdashboard/'+departmentId+'/'+regionId+ '/' +divisionId+ '/' +subDivisionId+ '/'+districtId+'/'+bolckId+'/' +villageId
        + '/' +financialYearId+ '/' + goId+'/'+SchemeId+'/' +ComponentId+'/' + MachineryId, refresh)

    }

    // financialYearId: this.year,
    // dbtGoId: this.go,
    // dbtSchemeId: this.scheme,
    // dbtComponentId: this.component,
    // dbtProductId: this.product,
    // regionId:this.regionId,
    // divisionId:this.divisionId?this.divisionId:0,
    // subDivisionId:0,
    // villageId:0,
    getsmamDashboardDrillData(data, refresh: boolean) {
        return this.dataService.getData('/api/SMAMdashboard/drildown/'+data.department + '/'+data.financialYearId+'/'+ data.dbtGoId+'/'+data.dbtSchemeId+'/'+
            data.dbtComponentId+'/'+data.dbtProductId+'/'+ data.regionId + '/' + data.divisionId + '/' + data.subDivisionId + '/' + data.villageId , refresh)
    }
}
